import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, CircularProgress, Tooltip, IconButton, Drawer } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { LabelValueCard, RevisionHistory, PageLoader, CustomChip, CustomDropzone, PreviewDocsModal, DeletePopUp } from '../../../../shared_elements';
import { fieldDateFormat, backendDateFormat, displayDateFormatShort } from '../../../../constants';
import { checkApiStatus, capitalizeFirstLetter, getLocalStorageInfo, checkPermission } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addEditLeaseOptionApi, getLeaseOptionApi } from '../apiServices';
import { errorCode, addLeaseOption } from '../';
import { avationPlcInstance, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
class LeaseOptionCRU extends Component{
  constructor(props){
    super(props);
    this.state = {
      modal:false,
      formSubmitLoader:false,
      pageLoader: false,
      mode:'',
      leaseOption:{},
      error:{},
      previewDocs: '',
      deleteAttachmentModal: false, 
      attachedDoc:[],
      deleteItem : {}
    }
    this.addEditLeaseOptionApi = addEditLeaseOptionApi.bind(this);
    this.getLeaseOptionApi = getLeaseOptionApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    if(['excess_refund','compensation_time','compensation_type','compensation_base','extension_start_date','extension_rent_type','extension_end_date','continuous','recurring'].includes(keyParam)){
      this.setState(prevState => ({
        leaseOption: {
          ...prevState.leaseOption,
          titan_extra_fields: {
            ...prevState.leaseOption?.titan_extra_fields,
            [keyParam]: data,
          },
        },
      }));
    }else{
    this.setState(prevState => ({
      ...prevState,
      leaseOption: {
        ...prevState.leaseOption,
        [keyParam]:data
      }
    }))
  }
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]:message
      }
    }))
  }
  getDeleteResponse = () => {
    const { leaseOption, deleteItem } = this.state
    const updatedAttachments = leaseOption?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      leaseOption: {
        ...prevState.leaseOption,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  toggleFnc = (key,status)=>{
    this.setState({[key] : status})
  }
  addEditLeaseOpFn = () => {
    const { leaseOption } = this.state;
    let validationInputs = {
      lease_option:errorCode['lease_option'][fieldValidation({...errorCode['lease_optionObj'], fieldval: leaseOption.lease_option })],
      details:errorCode['details'][fieldValidation({...errorCode['detailsObj'], fieldval: leaseOption.details})],
    };
    if(leaseOption.validity_start_date && leaseOption.validity_end_date){
      validationInputs = {
        ...validationInputs,
        validity_start_date: dateRangeValidation(leaseOption.validity_start_date, leaseOption.validity_end_date, 1)
      }
    }
    if(leaseOption.notice_period_start_date && leaseOption.notice_period_start_date){
      validationInputs = {
        ...validationInputs,
        notice_period_start_date: dateRangeValidation(leaseOption.notice_period_start_date, leaseOption.notice_period_end_date, 1)
      }
    }
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length+leaseOption?.attachments?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      let payload = Object.assign({}, leaseOption);
      payload = {
        ...payload,
        lease_option: leaseOption.lease_option.value
      }
      this.addEditLeaseOptionApi(this.props,payload)
      .then(response => {
        if(checkApiStatus(response)){
          if (this.state.attachedDoc?.length > 0) {
            addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "16", this.toggleFnc);
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this.props.getResponseBack();
          }
          this.setState({modal:false, mode:'', leaseOption:{}, error:{}});
        }else{
          this.props.enqueueSnackbar(response.data.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        }
      })
    }else{
      this.setState({error:validationInputs});
    }
  }
  render() {
    const { modal, mode, formSubmitLoader, leaseOption, error, pageLoader } = this.state;
    const { id, m, pltConstants, contractInfo } = this.props;
    return(
      <Fragment>
        { pageLoader ? <PageLoader />:null}
        { id ?
          <span onClick={() => this.getLeaseOptionApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{cursor:'pointer'}}/></Tooltip></span>:
          contractInfo?.hdlineInfo?.archived_asset ?
          null:
          <Button onClick={() => this.setState({modal:true, leaseOption:addLeaseOption, mode:'add'})} variant="contained" color="primary"><AddIcon fontSize='small'/>Add EOL Option</Button>
        }
        { modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({modal:false, mode:'', leaseOption:{}, error:{}})}
          >
          <div style={{width:'670px'}} className="drawer-container">
            <div className="drawer-header" alignItems='center'>
              <span className="left-blk">{`${capitalizeFirstLetter(mode)} Lease Option`}</span>
              <CloseIcon className="close-icon" onClick={()=> this.setState({modal:false})}/>
              { mode !== 'add' ?
                <ul className="list-inline right-blk">
                  <li className="list-inline-item">
                    <RevisionHistory
                      url='audit/contracts/ctleaseoptions/'
                      queryParams={{action:1, object_id:id}}
                      buttonType={false}
                    />
                  </li>
                  <li className="list-inline-item">
                    { contractInfo?.hdlineInfo?.archived_asset == false && checkPermission('contracts','eol_options', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({mode:'edit'})}><EditIcon className="edit-icon"/>Edit</span>}
                    {mode !== 'view' && <span className="cta" onClick={() => this.setState({mode:'view'})}><VisibilityIcon className="view-icon"/>View</span>}
                  </li>
                </ul>:null
              }
            </div>
            <div className="drawer-body" style={{position : "sticky"}}>
              <Grid container spacing={3}>
                { mode == 'view' ?
                  <LabelValueCard md={6} xs={12} label='Lease Option' value={leaseOption.lease_option && leaseOption.lease_option.label ? leaseOption.lease_option.label:'--'} /> :
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      options = {pltConstants.filter(item => item.type === 'lease_option_type')}
                      getOptionLabel={option => option.label}
                      value={leaseOption.lease_option ? leaseOption.lease_option:null}
                      id="lease_option"
                      onChange={(e, value) => {this.onFieldChange(e, 'lease_option', value); }}
                      renderInput={params => <TextField required onFocus={(e) => this.updateErrorField('lease_option', '')} error={error.lease_option ? true:false} helperText={error.lease_option?error.lease_option:''} {...params} label="Lease Option" placeholder="Select Lease Option" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                    />
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={6} xs={12} label='Validity	Start Date' value={leaseOption.validity_start_date ? moment(leaseOption.validity_start_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="validity_start_date"
                         label="Validity	Start Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                         error={error.validity_start_date ? true:false }
                         helperText={error.validity_start_date ? error.validity_start_date: ''}
                         value={leaseOption.validity_start_date ? leaseOption.validity_start_date:null}
                         onChange={(data, value) => {this.onFieldChange(value, 'validity_start_date', data?moment(data).format(backendDateFormat):data);this.updateErrorField('validity_start_date', '')}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={6} xs={12} label='Validity End Date' value={leaseOption.validity_end_date ? moment(leaseOption.validity_end_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="validity_end_date"
                         label="Validity End Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                         value={leaseOption.validity_end_date ? leaseOption.validity_end_date:null}
                         onChange={(data, value) => {this.onFieldChange(value, 'validity_end_date', data ? moment(data).format(backendDateFormat):data);this.updateErrorField('validity_start_date', '')}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={6} xs={12} label='Notice Period Start Date' value={leaseOption.notice_period_start_date ? moment(leaseOption.notice_period_start_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="notice_period_start_date"
                         label="Notice Period Start Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                         error={error.notice_period_start_date ? true:false }
                         helperText={error.notice_period_start_date ? error.notice_period_start_date: ''}
                         value={leaseOption.notice_period_start_date ? leaseOption.notice_period_start_date:null}
                         onChange={(data, value) => {this.onFieldChange(value, 'notice_period_start_date', data ? moment(data).format(backendDateFormat):data);this.updateErrorField('notice_period_start_date', '')}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={6} label='Notice Period End Date' value={leaseOption.notice_period_end_date ? moment(leaseOption.notice_period_end_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="start_date"
                         label="Notice Period End Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                         value={leaseOption.notice_period_end_date ? leaseOption.notice_period_end_date: null}
                         onChange={(data, value) => {this.onFieldChange(value, 'notice_period_end_date', data ? moment(data).format(backendDateFormat):data);this.updateErrorField('notice_period_start_date', '')}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Details' value={leaseOption.details ? ( <span dangerouslySetInnerHTML={{ __html: leaseOption.details.replace(/\n/g, '<br />')}}/>):'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="details"
                      label="Details"
                      fullWidth
                      margin="normal"
                      multiline
                      rows="6"
                      value={leaseOption.details ? leaseOption.details:''}
                      InputLabelProps={{shrink: true}}
                      error={error.details ? true:false }
                      helperText={error.details ? error.details: ''}
                      onChange={(e) => this.onFieldChange(e, 'details', e.target.value)}
                      onFocus={(e) => this.updateErrorField('details', '')}
                    />
                  </Grid>
                }
                {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance)?<>
                  { mode == 'view' ?
                  <LabelValueCard md={12} label='Extension Start Date' value={leaseOption?.titan_extra_fields?.extension_start_date ? moment(leaseOption?.titan_extra_fields?.extension_start_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="extension_start_date"
                         label="Extension Start Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                        //  disableFuture
                         error=''
                         helperText=''
                         value={leaseOption?.titan_extra_fields?.extension_start_date ? leaseOption?.titan_extra_fields?.extension_start_date:''}
                         onChange={(data, value) => {this.onFieldChange(value, 'extension_start_date', data ? moment(data).format(backendDateFormat):data)}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={6} label='Extension Rent Type' value={leaseOption?.titan_extra_fields?.extension_rent_type ? leaseOption?.titan_extra_fields?.extension_rent_type:'--'} /> :
                  <Grid item xs={6}>
                    <TextField
                      id="extension_rent_type"
                      label="Extension Rent Type"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'extension_rent_type', e.target.value)}
                      value={leaseOption?.titan_extra_fields?.extension_rent_type ? leaseOption?.titan_extra_fields?.extension_rent_type:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }   
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Extension End Date' value={leaseOption?.titan_extra_fields?.extension_end_date ? moment(leaseOption?.titan_extra_fields?.extension_end_date).format(displayDateFormatShort):'--'} /> :
                  <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                         margin="normal"
                         id="extension_end_date"
                         label="Extension End Date"
                         format={fieldDateFormat}
                         fullWidth
                         InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: true}}
                         clearable={true}
                        //  disableFuture
                         error=''
                         helperText=''
                         value={leaseOption?.titan_extra_fields?.extension_end_date ? leaseOption?.titan_extra_fields?.extension_end_date:''}
                         onChange={(data, value) => {this.onFieldChange(value, 'extension_end_date', data ? moment(data).format(backendDateFormat):data)}}
                       />
                      </MuiPickersUtilsProvider>
                  </Grid>
                }</>:null}
                {avationPlcInstance||leshaBankInstance||mtInstance?<>
                 { mode == 'view' ?
                  <LabelValueCard md={6} label='Continuous' value={leaseOption?.titan_extra_fields?.continuous ? leaseOption?.titan_extra_fields?.continuous:'--'} /> :
                  <Grid item xs={6}>
                    <TextField
                      id="continuous"
                      label="Continuous"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'continuous', e.target.value)}
                      value={leaseOption?.titan_extra_fields?.continuous ? leaseOption?.titan_extra_fields?.continuous:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>}
                  { mode == 'view' ?
                  <LabelValueCard md={6} label='Recurring' value={leaseOption?.titan_extra_fields?.recurring ? leaseOption?.titan_extra_fields?.recurring:'--'} /> :
                  <Grid item xs={6}>
                    <TextField
                      id="recurring"
                      label="Recurring"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'recurring', e.target.value)}
                      value={leaseOption?.titan_extra_fields?.recurring ? leaseOption?.titan_extra_fields?.recurring:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>}</>:null}
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Remarks' value={leaseOption.remarks ? ( <span dangerouslySetInnerHTML={{ __html: leaseOption.remarks.replace(/\n/g, '<br />')}}/>):'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="remarks"
                      label="Remarks"
                      fullWidth
                      margin="normal"
                      multiline
                      onChange={(e, value) => this.onFieldChange(e, 'remarks', e.target.value)}
                      rows="6"
                      value={leaseOption.remarks ? leaseOption.remarks:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s)  [Count: {leaseOption?.attachments?.length}]</p>
                      {leaseOption?.attachments?.length ? leaseOption?.attachments && leaseOption?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px'}}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation();  this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={leaseOption}
                          attachedDoc = {this.state.attachedDoc}
                        >
                        </CustomDropzone>
                        {leaseOption?.attachments && leaseOption?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px'}}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file })}}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
              </Grid>
            </div>
            <div className="drawer-footer">
              { mode !== 'view' ?
                <Button onClick={this.addEditLeaseOpFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                  { formSubmitLoader ? <CircularProgress color="#ffffff" size={24} />:'Save Changes' }
                </Button>:null
              }
              <Button onClick={() => this.setState({modal:false, mode:'', leaseOption:{}, error:{}})} color="primary" style={mode == 'view' ? {marginLeft:'auto', paddingLeft:'0px'}:{marginLeft:'8px'}}>Cancel</Button>
            </div>
          </div>
          </Drawer>:null
        }

      {
        this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs}  toggleModalFn={() => this.setState({ previewDocs: '' })}/> : null
      }
      {this.state.deleteAttachmentModal ?
        <DeletePopUp
          modal={this.state.deleteAttachmentModal}
          toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
          title="Delete Attachment"
          content={<h4>Are you sure you want to delete?</h4>}
        deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem,this.toggleFnc,this.getDeleteResponse)}
        /> : null
      }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(LeaseOptionCRU));
